import { render, staticRenderFns } from "./downStock.vue?vue&type=template&id=907b19d6&scoped=true&"
import script from "./downStock.vue?vue&type=script&lang=js&"
export * from "./downStock.vue?vue&type=script&lang=js&"
import style0 from "./downStock.vue?vue&type=style&index=0&id=907b19d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907b19d6",
  null
  
)

export default component.exports